import "jspdf-autotable";
import moment from "moment";
import Alert from "@mui/material/Alert";
import React from "react";
import Snackbar from "@mui/material/Snackbar";
import { jsPDF } from "jspdf";
import ReportHeader from "../reportHeader";
import PatientZipcodeReportTable from "../PatientZipcodeReport/components/PatientZipcodeReportTable"
import { useGetPatientZipcodeReportMutation } from "../../../features/report/reportApiSlice";
import ReusableModal from "../../../components/Modals/ReusableModal";
import { useGetPatientByZipcodeMutation } from "../../../features/report/reportApiSlice";

function index() {
    const [open, setOpen] = React.useState(false);
    const [message, setMessage] = React.useState("Something went wrong");
    const handleClose = () => {
      setOpen(false);
    };
    const [totals, setTotals] = React.useState([
        { name: "Total Records Found", value: 0 },
    ]);
    const [patientzipcodeReports, setPatientZipcodeReports] = React.useState([]);
    const [selectedZipcodes, setSelectedZipcodes] = React.useState([]);
    const [zipCodes, setZipCodes] = React.useState([]);
    const [isSelectAllZipcodes, setIsSelectAllZipcodes] = React.useState(true);
    const [clear, setClear] = React.useState(true);
    const [isSelecetdValue, setIsSelectedValue] = React.useState(false);
    const [filteredPt, setFilteredPt] = React.useState([]);
     const [isModalOpen, setIsModalOpen] = React.useState(false);
     const [patientZipcodeData, setPatientZipcodeData] = React.useState([]);
    const DAY_MAP = {
    MONDAY: "M",
    TUESDAY: "T",
    WEDNESDAY: "W",
    THURSDAY: "Th",
    FRIDAY: "F",
    SATURDAY: "Sa",
    SUNDAY: "Su",
    };
    const tableModalHeaders = [
      "Patient Name",
      "EHR ID",
      "Last Visit Date",
      "Assigned Provider",
    ];

    const [getProviderZipcodeReport] = useGetPatientZipcodeReportMutation();
    const [getPatientByZipcode]=useGetPatientByZipcodeMutation();

    const getPatientsByZip = async (zip) => {
      try {
        const response = await getPatientByZipcode({ zip }).unwrap();
        setPatientZipcodeData(response?.data); 
        setIsModalOpen(true);            
      } catch (err) {
        console.log("Error fetching patients by zipcode:", err);
      }
    };

    const getProviderReports = async (filters) => {
        try {
          const providerActivityReport = await getProviderZipcodeReport({
            zip: filters.setHeaders ? "" : selectedZipcodes,
          }).unwrap();
          setPatientZipcodeReports(
            [...providerActivityReport.data.report_data]
          );
          setTotals([
            {
              name: "Total Zip Codes",
              value: providerActivityReport?.data?.total_zip,
            },
            {
              name: "Total Patients",
              value: `${providerActivityReport.data.total_patients}`,
            },
          ]);
          if (filters.setHeaders === true) {
            const zipcodes = providerActivityReport?.data?.report_data?.map((item) => item.zipCode);
            setZipCodes([...new Set(zipcodes)]);
            setSelectedZipcodes([...new Set(zipcodes)]);
            setFilteredPt([...new Set(zipcodes)]);
          }
        } catch (err) {
          setOpen(true);
          setMessage(err?.response?.data?.message);
        }
    };
    const handleZipcodeFilter = (zipcode, obj) => {
        setClear(false);
        if (obj.selectAll === true) {
        if (obj.isSelectAll) {
            setSelectedZipcodes(zipCodes)
        } else {
            setSelectedZipcodes([])
        }
        } else {
        if (selectedZipcodes.includes(zipcode)) {
            setSelectedZipcodes(
            selectedZipcodes.filter((filter) => filter !== zipcode)
            );
        } else {
            setSelectedZipcodes([...selectedZipcodes, zipcode]);
        }
        }
    };
   
    const parseNull = (value, replacement = "NA", type = "string") => {
        return value === null || (Array.isArray(value) && value.length === 0)
          ? replacement
          : Array.isArray(value)
            ? value.map((day) => DAY_MAP[day]).join(", ")
            : type === "date"
              ? moment(value).format("DD/MM/YYYY")
              : value;
    };
    const exportPDF = () => {
        if (patientzipcodeReports?.length > 0) {
          const doc = new jsPDF();
          doc.text("Provider Zip Code Report", 20, 10);
          doc.autoTable({
            styles: { halign: "center" },
            headStyles: { fillColor: [245, 247, 249] },
            html: "#providerZipcodeReport",
            theme: "plain",
            didParseCell: function (data) {
              if (data.row.index === 0 || data.row.index % 2 === 0) {
                data.cell.styles.fillColor = [255, 255, 255]; // White color for even rows
              } else {
                data.cell.styles.fillColor = [245, 247, 249]; // Light blue color for odd rows
              }
            },
          });
          doc.setFont("helvetica", "normal");
          doc.setFontSize(13);
          doc.setTextColor(0, 0, 0);
          doc.text(
            `Total Zip Codes: ${totals[0].value}\nTotal Patients: ${totals[1].value}`,
            15,
            doc.lastAutoTable.finalY + 10
          );
          doc.save("provider-zipcode-report.pdf");
        } else {
          alert("No Records Found");
        }
    };
    const exportCSV = () => {
        if (patientzipcodeReports?.length > 0) {
        let csvContent =
            "Zip code,No. of Patients\r\n";
        patientzipcodeReports?.forEach((patient) => {
            const row = [
            parseNull(patient.zipCode),
            parseNull(patient.patientCount),
            ];
            csvContent += row.join(",") + "\r\n";
        });

        // Add extra data at the bottom of the CSV
        csvContent += `\r\nTotal Zip Codes: ${totals[0].value}`;
        csvContent += `\r\nTotal Patients: ${totals[1].value}`;

        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", "provider-zipcode-report.csv");
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        } else {
        alert("No Records Found");
        }
    };
    React.useEffect(() => {
        if (!clear) {
          getProviderReports({ setHeaders: false});
        }
        if (
          selectedZipcodes?.length > 0 
        ) {
          setIsSelectedValue(true);
        } else {
          setIsSelectedValue(false);
        }
    }, [selectedZipcodes]);
    React.useEffect(() => {
        getProviderReports({ setHeaders: true });
        if (
            selectedZipcodes?.length > 0 
        ) {
            setIsSelectedValue(true);
        } else {
            setIsSelectedValue(false);
        }
    }, []);

    return (
        <div className="relative flex flex-col w-full overflow-auto no-scrollbar standard-reports" style={{ height: "89vh" }}>
            <Snackbar
                onClose={handleClose}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                open={open}
                autoHideDuration={6000}
                message={message ? message : "Something went wrong"}
                severity="error"
            >
                <Alert
                onClose={handleClose}
                severity="error"
                variant="filled"
                sx={{ width: "100%" }}
                >
                {message ? message : "Something went wrong"}
                </Alert>
            </Snackbar>
            {
              isModalOpen && 
              <ReusableModal
                open
                onClose={() => {
                  setIsModalOpen(!isModalOpen);
                }}
                title={"Patient List"}
              >
              <div className="px-4 py-3 w-[50rem] flex flex-col gap-2">
                <span className="text-[12px]"><b>*</b> Patients with 'NA' in the Visit Date or Assigned Provider columns do not have any scheduled appointments.</span>
                <div className="max-h-[500px] overflow-y-auto zipcodedata custom-scrollbar">
                  <table className="min-w-full table-fixed border-collapse">
                    <thead className="top-[-1px]">
                      <tr>
                        {tableModalHeaders.map((header, index) => (
                          <th
                            key={index}
                            className="px-4 py-1 text-center text-sm font-semibold text-gray-700 zipcodedata
                                      sticky top-0 bg-[#d1e0fb] z-20"
                          >
                            {header}
                          </th>
                        ))}
                      </tr>
                    </thead>

                    <tbody>
                      {patientZipcodeData && patientZipcodeData.length > 0 ? (
                        patientZipcodeData.map((patient, index) => (
                          <tr key={index} className="hover:bg-primarylightgrey">
                            <td className="px-4 py-1 text-center text-[12px] text-gray-800 border border-gray-300">
                              {patient.patient_name}
                            </td>
                            <td className="px-4 py-1 text-center text-[12px] text-gray-800 border border-gray-300">
                              {patient.ehr_id}
                            </td>
                            <td className="px-4 py-1 text-center text-[12px] text-gray-800 border border-gray-300">
                             {patient.visit_date
                              ? new Date(patient.visit_date).toLocaleDateString()
                              : "NA"}
                            </td>
                            <td className="px-4 py-1 text-center text-[12px] text-gray-800 border border-gray-300">
                              {patient.provider_name ?? "NA"}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan={tableModalHeaders.length}
                            className="px-4 py-4 text-center text-gray-500 text-[14px] font-semibold"
                          >
                            No Data Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="w-full flex justify-end mr-2">
                  <button className="px-3 text-sm bg-primaryblue py-1 font-bold text-white rounded-md" 
                    onClick={()=>{
                      setIsModalOpen(false)
                    }}
                  >
                    Close
                  </button>
                </div>
              </div>

              </ReusableModal>
            }
            <ReportHeader
                title="Patient Zip Code Report"
                exportCSV={exportCSV}
                exportPDF={exportPDF}
                totals={totals}
                total={patientzipcodeReports.length}
            />
            <div
                className="p-2 d-flex flex-column align-items-center"
                style={{ height: "77vh" }}
            >
                <PatientZipcodeReportTable
                    patientzipcodeReports={patientzipcodeReports}
                    setPatientZipcodeReports={setPatientZipcodeReports}
                    selectedZipcodes={selectedZipcodes}
                    zipCodes={zipCodes}
                    setIsSelectAllZipcodes={setIsSelectAllZipcodes}
                    isSelectAllZipcodes={isSelectAllZipcodes}
                    handleZipcodeFilter={handleZipcodeFilter}
                    setFilteredPt={setFilteredPt}
                    filteredPt={filteredPt}
                    getPatientsByZip={getPatientsByZip}
                />
            
            </div>
        </div>
    );
}
export default index;